import { useIntl } from "react-intl";
import GridHighlightedValue from "../../../components/OrderGridV3/GridHighlightedValue/GridHighlightedValue";

const StatusCellRenderer = ({ value, rendererParams }: { value: any; rendererParams: any }) => {
    const intl = useIntl();
    const statusLabel = value
        ? intl.formatMessage({ id: "common.field-label.active", defaultMessage: "Active" })
        : intl.formatMessage({ id: "common.field-label.inactive", defaultMessage: "Inactive" });
    return (
        <span>
            <GridHighlightedValue {...rendererParams} columnKey="isActive" value={statusLabel} enableCopyToClipboard />
        </span>
    );
};

export default StatusCellRenderer;
